import React, { useCallback } from "react";
import { toast } from "react-toastify";

import { useDialog } from "@/contexts/DialogContext";

import { Button } from "../core/Button";

export const LoginButton = () => {
  return (
    <WithLogin>
      {(doLogin) => (
        <Button onPress={doLogin}>
          Login
        </Button>
      )}
    </WithLogin>
  );
};

export const WithLogin = ({
  children,
}: {
  children: (doLogin: () => void) => React.ReactNode;
}) => {
  const { dispatch } = useDialog();

  const doLogin = useCallback(() => {
    fetch("/api/login").then(async (res) => {
      const data = await res.json();
      if (data.success) {
        dispatch({
          action: "OPEN_DIALOG",
          dialog: { id: "LOGIN_INFO", mode: "NORMAL", url: data.redirect },
        });
      } else {
        if ("error" in data) {
          toast.error("Error while logging in: " + data.error);
        }
        if ("mode" in data) {
          dispatch({
            action: "OPEN_DIALOG",
            dialog: { id: "LOGIN_INFO", mode: data.mode },
          });
        }
      }
    });
  }, []);

  return children(doLogin);
};
